var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOutlet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.575,
    height: 9.575,
    viewBox: "0 0 9.575 9.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1785.034,2115.145a4.787,4.787,0,1,0,4.788,4.787A4.787,4.787,0,0,0,1785.034,2115.145Zm-1.024,4.816h-.85v-1.643h.85Zm1.762,3.409H1784.3v-1.437a.738.738,0,0,1,.738-.738h0a.737.737,0,0,1,.738.738Zm1.137-3.131h-.851v-2.2h.851Z",
    transform: "translate(-1780.247 -2115.145)",
    fill: "#3d3d3d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlet);
export default __webpack_public_path__ + "static/media/ic-outlet.d2a5ef84a719096fd83d8ea8e87577c1.svg";
export { ForwardRef as ReactComponent };